import React from 'react';

const ContactFormField = ({ label, type, name, id, placeholder, isTextArea }) => {
  return (
    <div className="contact__form-field">
      <label className="contact__form-label" htmlFor={id}>{label}</label>
      {isTextArea ? (
        <textarea
          required
          cols="30"
          rows="10"
          className="contact__form-input"
          placeholder={placeholder}
          name={name}
          id={id}
        ></textarea>
      ) : (
        <input
          required
          placeholder={placeholder}
          type={type}
          className="contact__form-input"
          name={name}
          id={id}
        />
      )}
    </div>
  );
};

export default ContactFormField;